<!-- DIALOG DEPÓSITO -->
<template>
  <div>
    <v-dialog v-model="local" persistent max-width="300">
      <v-card>
        <v-card-title class="mb-0 pb-0">
          <div>
            <h3 class="headline mb-0">Pagamento</h3>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog(true)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="pt-3">
            <p class="white--text">
              Para realizar o pagamento via pix faça a leitura do Qr Code do
              aplicativo do seu banco ou link para pagamento
            </p>
            <span class="pt-4 white--text">
              Valor do depósito: {{ $t("labelCurrency") }}
              {{ itemQrcode.value || itemQrcode.value_requested }}
            </span>
          </div>
          <v-img
            :src="itemQrcode.qrcode"
            max-height="250px"
            max-width="250px"
            class="mb-2 mt-2"
            style="background: white !important"
          ></v-img>
          <div class="pt-1 white--text text-center">OU</div>
        </v-card-text>
        <v-card-actions>
          <v-divider></v-divider>
          <v-btn @click="$copy(itemQrcode.code)" color="primary">
            <v-icon small left>mdi-content-copy</v-icon>Código pix</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Dialog-qrcode",

  data: () => ({
    //Deposit
    valueDeposit: "",
    checkingDepositIntervalId: 0,
    times: 0,
    local: false,
  }),

  computed: {
    status() {
      return this.$store.state.dialogQrcode.status;
    },
    itemQrcode() {
      return this.$store.state.dialogQrcode.obj;
    },
  },

  mounted() {
    this.closeDialog();
  },

  destroyed() {
    clearInterval(this.checkingDepositIntervalId);
  },

  watch: {
    checkingDepositIntervalId(val) {
      if (val == 0) {
        this.times = 0;
      }
    },
    status(val) {
      this.local = val;
    },
  },

  methods: {
    closeDialog(watchBalance = false) {
      if (watchBalance) {
        clearInterval(this.checkingDepositIntervalId);

        this.times = 0;
        this.checkBalanceOnline();
        this.checkingDepositIntervalId = setInterval(() => {
          this.checkBalanceOnline();
        }, 5000);
      }

      this.$store.commit("showDialogQrcode", {
        status: false,
        obj: {},
      });
    },

    checkBalanceOnline() {
      if (this.times === 3) {
        clearInterval(this.checkingDepositIntervalId);
        return;
      }

      this.times = this.times + 1;

      this.$axios.get("/player/online/bank/balanceOnline").then((resp) => {
        const cash = Number(this.$store.state.cash);
        const cashResp = Number(resp.data.dados.balance);

        this.$store.commit("setCash", resp.data.dados.balance);
        this.$store.commit("setBonus", {
          value: resp.data.dados.balance_bonus,
          status: resp.data.dados.balance_bonus_status,
        });

        this.$store.commit("setAvailableBalance", resp.data.dados.available_balance);
        this.$store.commit("setRestrictedBalance", resp.data.dados.restricted_balance);

        if (cashResp > cash) {
          this.$axios
            .post("/player/user/qtyPlayerDeposits")
            .then((response) => {
              if (response.data.dados.qty_deposits === "1") {
                this.$gtag.first_deposit(
                  this.feedbackDeposit,
                  "backoffice_historic"
                );

                // Primeiro Depósito - Active Campaign
                this.$activeCampaign("firstDeposit");
                // Primeiro Depósito - Zendesk
                this.$zendesk("firstDeposit");
                // Primeiro Depósito - Rd Station
                this.$rdStation("firstDeposit");
              }
            });

          this.$gtag.consolidated_pix(
            this.feedbackDeposit,
            "backoffice_historic"
          );

          clearInterval(this.checkingDepositIntervalId);
        }
      });
    },
  },
};
</script>
